import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class ChannelApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.CHANNEL);
  }
}

export default new ChannelApi();
